import React from 'react';
import { useSelector } from 'react-redux';
import {
  Bar,
  BarChart,
  Brush,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { IChartProps } from '../../../../../component/charts';
import ChartCard from '../../../../../component/charts/chartCard';
import { colors } from '../../../../../shared/constants';
import { labelFormatterNumber } from '../../../../../shared/formatters/formatters';
import { ExistingRealtiesChartData } from '../types/realtyTransactions.types';

export const ExistingRealties: React.FC = () => {
  const { requestStatusT, chartsDataTransactions } = useSelector(
    (state: any) => state.realtyTransactionsState
  );
  return (
    <ChartCard
      data={chartsDataTransactions['existing_realties']}
      cy={'ExistingRealties'}
      id={'existingRealties'}
      Chart={ExistingRealtiesChart}
      requestStatus={requestStatusT['migratoryOrigin']}
      hasAnnualDataOnly={true}
    />
  );
};

const ExistingRealtiesChart: React.FC<
  IChartProps<ExistingRealtiesChartData[]>
> = ({ data, cy, id }) => {
  return (
    <ResponsiveContainer data-cy={`${cy}ChartContainer`}>
      <BarChart data={data} id={id}>
        <Tooltip labelFormatter={labelFormatterNumber} />
        <CartesianGrid strokeDasharray="3 3 3" />
        <XAxis dataKey="period" />
        <YAxis tickFormatter={labelFormatterNumber} />
        <Bar dataKey="value" name="Imóveis existentes" fill={colors[0]}></Bar>
        <Brush dataKey="period" height={30} stroke="#8884d8" />
      </BarChart>
    </ResponsiveContainer>
  );
};
